export default __webpack_public_path__ + "static/hw_ff_buzzer_schem-e8deb1d09892df7376fe6b7fc835d6a2.png";